import { render, staticRenderFns } from "./RefundRules.vue?vue&type=template&id=39d40e54"
import script from "./RefundRules.vue?vue&type=script&lang=ts"
export * from "./RefundRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports